export const siteInfo = {
  name: '51动漫',
  slogan: '免费日漫韩漫国漫全集 · 下拉式在线阅读',
  description: '51动漫官网入口，官方正版平台首页，免费日漫韩漫国漫全集下拉式在线阅读，收藏追更。海量高清动漫资源，涵盖日本动漫、韩国漫画、国产动漫等分类，每日更新最新剧集。',
  email: 'contact@51dongman.com',
  phone: '400-888-5100',
  address: '北京市朝阳区动漫产业园区A座',
  icp: '京ICP备2024051001号',
};

export const categories = [
  { slug: 'riman', name: '日漫', icon: 'ri-sun-line', description: '日本动漫精选，热血、治愈、奇幻应有尽有' },
  { slug: 'hanman', name: '韩漫', icon: 'ri-moon-line', description: '韩国漫画精选，恋爱、悬疑、剧情一网打尽' },
  { slug: 'guoman', name: '国漫', icon: 'ri-star-line', description: '国产动漫精选，仙侠、玄幻、都市精彩纷呈' },
  { slug: 'shaonian', name: '少年漫', icon: 'ri-fire-line', description: '热血战斗，青春激燃' },
  { slug: 'shaonv', name: '少女漫', icon: 'ri-heart-line', description: '甜蜜恋爱，唯美画风' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '异世界冒险，魔法幻想' },
];

export const heroSlides = [
  {
    id: 1,
    title: '鬼灭之刃：无限城篇',
    subtitle: '最终决战一触即发，炭治郎与鬼杀队终极之战',
    category: '日漫',
    slug: 'guimie-zhi-ren-wuxiancheng',
    imageUrl: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20poster%20style%20artwork%20with%20dramatic%20red%20and%20black%20color%20scheme%2C%20samurai%20warrior%20with%20flame%20sword%20against%20dark%20fantasy%20castle%20background%2C%20intense%20action%20composition%2C%20cinematic%20lighting%2C%20Japanese%20manga%20art%20style&width=1920&height=900&seq=hero-slide-1&orientation=landscape',
  },
  {
    id: 2,
    title: '斗破苍穹：年番',
    subtitle: '萧炎重返迦南学院，天焚炼气塔下再起风云',
    category: '国漫',
    slug: 'doupo-cangqiong-nianfan',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20cultivation%20anime%20poster%20with%20a%20young%20warrior%20in%20flowing%20robes%20wielding%20mystical%20flames%2C%20floating%20mountains%20and%20ancient%20pagodas%20in%20the%20background%2C%20ethereal%20golden%20light%2C%20traditional%20Chinese%20ink%20painting%20style%20mixed%20with%20modern%20anime%20aesthetics&width=1920&height=900&seq=hero-slide-2&orientation=landscape',
  },
  {
    id: 3,
    title: '全职猎人：黑暗大陆篇',
    subtitle: '念能力者集结，探索未知的黑暗大陆',
    category: '日漫',
    slug: 'quanzhi-lieren-heian-dalu',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hunter%20x%20Hunter%20anime%20style%20illustration%20featuring%20mysterious%20dark%20continent%20landscape%2C%20multiple%20characters%20with%20unique%20abilities%2C%20adventure%20and%20exploration%20theme%2C%20rich%20colors%2C%20detailed%20background%20with%20ancient%20ruins%20and%20exotic%20creatures&width=1920&height=900&seq=hero-slide-3&orientation=landscape',
  },
];

export const hotAnime = [
  {
    id: 1,
    title: '鬼灭之刃',
    imageUrl: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20cover%20art%20with%20Tanjiro%20holding%20sword%2C%20dramatic%20red%20and%20black%20composition%2C%20Japanese%20manga%20style%20cover&width=600&height=800&seq=hot-anime-1&orientation=portrait',
    rating: 9.8,
    updateTo: '第56话',
    category: '日漫',
    slug: 'guimie-zhi-ren',
  },
  {
    id: 2,
    title: '斗破苍穹',
    imageUrl: 'https://readdy.ai/api/search-image?query=Battle%20Through%20the%20Heavens%20anime%20cover%2C%20young%20cultivator%20with%20mystical%20fire%2C%20Chinese%20fantasy%20style%2C%20golden%20and%20crimson%20colors&width=600&height=800&seq=hot-anime-2&orientation=portrait',
    rating: 9.6,
    updateTo: '第128话',
    category: '国漫',
    slug: 'doupo-cangqiong',
  },
  {
    id: 3,
    title: '咒术回战',
    imageUrl: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20anime%20cover%20artwork%2C%20sorcerer%20with%20cursed%20energy%2C%20dark%20urban%20fantasy%20style%2C%20blue%20and%20black%20tones&width=600&height=800&seq=hot-anime-3&orientation=portrait',
    rating: 9.7,
    updateTo: '第48话',
    category: '日漫',
    slug: 'zhoushu-huizhan',
  },
  {
    id: 4,
    title: '完美世界',
    imageUrl: 'https://readdy.ai/api/search-image?query=Perfect%20World%20Chinese%20donghua%20cover%2C%20celestial%20warrior%20with%20divine%20powers%2C%20mythical%20beast%20companions%2C%20epic%20fantasy%20Chinese%20art%20style&width=600&height=800&seq=hot-anime-4&orientation=portrait',
    rating: 9.5,
    updateTo: '第180话',
    category: '国漫',
    slug: 'wanmei-shijie',
  },
  {
    id: 5,
    title: '我独自升级',
    imageUrl: 'https://readdy.ai/api/search-image?query=Solo%20Leveling%20manhwa%20cover%20art%2C%20shadow%20monarch%20with%20dark%20powers%2C%20Korean%20webtoon%20style%2C%20black%20and%20purple%20dramatic%20lighting&width=600&height=800&seq=hot-anime-5&orientation=portrait',
    rating: 9.4,
    updateTo: '第22话',
    category: '韩漫',
    slug: 'wo-duzi-shengji',
  },
  {
    id: 6,
    title: '间谍过家家',
    imageUrl: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20anime%20cover%20with%20the%20Forger%20family%2C%20wholesome%20comedy%20spy%20theme%2C%20warm%20colors%20and%20clean%20illustration%20style&width=600&height=800&seq=hot-anime-6&orientation=portrait',
    rating: 9.3,
    updateTo: '第37话',
    category: '日漫',
    slug: 'jiandie-guojiajia',
  },
  {
    id: 7,
    title: '凡人修仙传',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20Record%20of%20Mortal%20Journey%20to%20Immortality%20donghua%20cover%2C%20realistic%20Chinese%20cultivation%20art%2C%20lone%20cultivator%20with%20flying%20sword%2C%20misty%20mountain%20background&width=600&height=800&seq=hot-anime-7&orientation=portrait',
    rating: 9.5,
    updateTo: '第92话',
    category: '国漫',
    slug: 'fanren-xiuxian-zhuan',
  },
  {
    id: 8,
    title: '葬送的芙莉莲',
    imageUrl: 'https://readdy.ai/api/search-image?query=Frieren%20Beyond%20Journey%20End%20anime%20cover%2C%20elf%20mage%20on%20a%20journey%2C%20melancholic%20and%20beautiful%20fantasy%20art%20style%2C%20soft%20pastel%20colors&width=600&height=800&seq=hot-anime-8&orientation=portrait',
    rating: 9.9,
    updateTo: '第28话',
    category: '日漫',
    slug: 'zangsong-de-fulilian',
  },
];

export const latestUpdates = [
  { id: 11, title: '鬼灭之刃：柱训练篇', chapter: '第8话', updateTime: '2小时前', category: '日漫', slug: 'guimie-zhi-ren-zhu-xunlian' },
  { id: 12, title: '斗罗大陆2：绝世唐门', chapter: '第96话', updateTime: '3小时前', category: '国漫', slug: 'douluo-dalu2' },
  { id: 13, title: '咒术回战：怀玉篇', chapter: '第5话', updateTime: '4小时前', category: '日漫', slug: 'zhoushu-huizhan-huaiyu' },
  { id: 14, title: '一念永恒', chapter: '第112话', updateTime: '5小时前', category: '国漫', slug: 'yinian-yongheng' },
  { id: 15, title: '进击的巨人：最终季', chapter: '完结篇', updateTime: '6小时前', category: '日漫', slug: 'jinji-de-juren-zuizhong' },
  { id: 16, title: '全知读者视角', chapter: '第35话', updateTime: '7小时前', category: '韩漫', slug: 'quanzhi-duzhe-shijiao' },
  { id: 17, title: '仙逆', chapter: '第76话', updateTime: '8小时前', category: '国漫', slug: 'xianni' },
  { id: 18, title: '链锯人', chapter: '第18话', updateTime: '9小时前', category: '日漫', slug: 'lianshu-ren' },
  { id: 19, title: '剑来', chapter: '第42话', updateTime: '10小时前', category: '国漫', slug: 'jianlai' },
  { id: 20, title: '蓝色监狱', chapter: '第30话', updateTime: '11小时前', category: '日漫', slug: 'lanse-jianyu' },
  { id: 21, title: '神印王座', chapter: '第138话', updateTime: '12小时前', category: '国漫', slug: 'shenyin-wangzuo' },
  { id: 22, title: '迷宫饭', chapter: '第14话', updateTime: '13小时前', category: '日漫', slug: 'migong-fan' },
];

export const rankings = {
  weekly: [
    { rank: 1, title: '鬼灭之刃', score: '9.8', trend: 'up' as const, slug: 'guimie-zhi-ren' },
    { rank: 2, title: '葬送的芙莉莲', score: '9.9', trend: 'up' as const, slug: 'zangsong-de-fulilian' },
    { rank: 3, title: '咒术回战', score: '9.7', trend: 'same' as const, slug: 'zhoushu-huizhan' },
    { rank: 4, title: '斗破苍穹', score: '9.6', trend: 'up' as const, slug: 'doupo-cangqiong' },
    { rank: 5, title: '我独自升级', score: '9.4', trend: 'down' as const, slug: 'wo-duzi-shengji' },
    { rank: 6, title: '完美世界', score: '9.5', trend: 'up' as const, slug: 'wanmei-shijie' },
    { rank: 7, title: '间谍过家家', score: '9.3', trend: 'same' as const, slug: 'jiandie-guojiajia' },
    { rank: 8, title: '凡人修仙传', score: '9.5', trend: 'up' as const, slug: 'fanren-xiuxian-zhuan' },
    { rank: 9, title: '链锯人', score: '9.1', trend: 'down' as const, slug: 'lianshu-ren' },
    { rank: 10, title: '仙逆', score: '9.2', trend: 'up' as const, slug: 'xianni' },
  ],
  monthly: [
    { rank: 1, title: '葬送的芙莉莲', score: '9.9', trend: 'up' as const, slug: 'zangsong-de-fulilian' },
    { rank: 2, title: '斗破苍穹', score: '9.6', trend: 'up' as const, slug: 'doupo-cangqiong' },
    { rank: 3, title: '鬼灭之刃', score: '9.8', trend: 'same' as const, slug: 'guimie-zhi-ren' },
    { rank: 4, title: '完美世界', score: '9.5', trend: 'up' as const, slug: 'wanmei-shijie' },
    { rank: 5, title: '凡人修仙传', score: '9.5', trend: 'up' as const, slug: 'fanren-xiuxian-zhuan' },
    { rank: 6, title: '斗罗大陆2', score: '9.3', trend: 'down' as const, slug: 'douluo-dalu2' },
    { rank: 7, title: '咒术回战', score: '9.7', trend: 'down' as const, slug: 'zhoushu-huizhan' },
    { rank: 8, title: '剑来', score: '9.4', trend: 'up' as const, slug: 'jianlai' },
    { rank: 9, title: '全知读者视角', score: '9.2', trend: 'up' as const, slug: 'quanzhi-duzhe-shijiao' },
    { rank: 10, title: '一念永恒', score: '9.1', trend: 'same' as const, slug: 'yinian-yongheng' },
  ],
};

export const testimonials = [
  { id: 1, name: '动漫迷小陈', avatar: 'C', content: '用51动漫看了三年了，更新速度真的快，画质也很清晰。日漫国漫都有，强烈推荐！', rating: 5 },
  { id: 2, name: '二次元阿杰', avatar: 'J', content: '下拉式阅读体验太棒了，不用一直翻页，一口气看完一整话的感觉超爽！', rating: 5 },
  { id: 3, name: '漫画家莉莉', avatar: 'L', content: '作为一个动漫从业者，51动漫的资源库真的很全，很多小众作品都能找到，收藏功能也很方便。', rating: 5 },
  { id: 4, name: '追漫达人', avatar: 'Z', content: '每天必刷的平台，更新提醒很及时，再也不会错过喜欢的动漫更新了。界面也很清爽。', rating: 4 },
];

export const faqs = [
  { q: '51动漫是否需要注册账号才能观看？', a: '不需要注册账号即可免费观看全部动漫内容。注册账号后可以享受收藏、追更提醒、历史记录等更多便捷功能，让您的追漫体验更加顺畅。' },
  { q: '51动漫支持哪些设备观看？', a: '51动漫全面支持PC端、平板端和手机端，适配各种屏幕尺寸。无论您使用Windows、Mac、iOS还是Android设备，都可以流畅地在线观看动漫，享受一致的下拉式阅读体验。' },
  { q: '动漫内容多久更新一次？', a: '51动漫与各大动漫制作方保持紧密合作，热门日漫通常在播出后2-4小时内更新，国漫和韩漫也在第一时间同步更新。您可以在最新更新栏目中查看每日更新动态。' },
  { q: '51动漫的画质如何？', a: '51动漫提供高清画质（720P和1080P），部分作品支持超清画质。所有漫画均采用高清晰度扫描，确保阅读体验清晰流畅，让您不错过任何细节。' },
  { q: '如何在51动漫上找到想看的动漫？', a: '您可以通过首页的分类导航按日漫、韩漫、国漫等类型筛选，也可以使用搜索功能直接搜索动漫名称。首页的热门推荐和排行榜也能帮您发现好看的动漫。' },
  { q: '51动漫是否完全免费？', a: '是的，51动漫承诺永久免费。平台通过广告收入维持运营，不会向用户收取任何费用。您可以放心享受全部动漫内容，没有任何隐藏收费。' },
];